// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderUserPreferences\ApiPilotJobOrderUserPreferences.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PilotJobOrderUserPreferencesData is the class that PilotJobOrderUserPreferences serializes to/from
export interface PilotJobOrderUserPreferencesData {
    PilotJobOrderId : number;
    Url : string | null;
    UserId : number;
	
    PilotJobOrder : PilotJobOrderData | null;
    User : PCUserData | null;
	
    RemarksVisible : boolean;
}

// PilotJobOrderUserPreferencesOptions is the class which may be passed to the PilotJobOrderUserPreferences constructor to define optional initial data values
export interface PilotJobOrderUserPreferencesOptions {
    PilotJobOrderId : number;
    Url? : string | null;
    UserId : number;
	
    PilotJobOrder? : PilotJobOrderOptions | null;
    User? : PCUserOptions | null;
	
    RemarksVisible? : boolean;
}

export class PilotJobOrderUserPreferences {
    public PilotJobOrderId : DataSignal<number>;
    public Url : DataSignal<string | null>;
    public UserId : DataSignal<number>;
	
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
    public User : DataSignal<PCUser | null>;
	
    public RemarksVisible : DataSignal<boolean>;

    constructor();
    constructor(data : PilotJobOrderUserPreferencesOptions);
    constructor(data: PilotJobOrderUserPreferencesOptions | null = null) {
        this.PilotJobOrderId = jsonableObservable(S.value<number>(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
        this.User = S.value<PCUser | null>(null);
	    
        this.RemarksVisible = jsonableObservable(S.value<boolean>(data && data.RemarksVisible !== undefined ? data.RemarksVisible : false));
    }

    static key(obj : PilotJobOrderUserPreferences) {
        return obj.PilotJobOrderId() + '\u2618' + obj.UserId();
    }
    
    static dataKey(obj : PilotJobOrderUserPreferencesOptions) {
        return obj.PilotJobOrderId + '\u2618' + obj.UserId;
    }

    static update(obj : PilotJobOrderUserPreferences, data : PilotJobOrderUserPreferencesOptions) {
        S.freeze(() => {
            if (data.PilotJobOrderId !== undefined) obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.Url !== undefined) obj.Url(data.Url);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
            if (data.RemarksVisible !== undefined) obj.RemarksVisible(data.RemarksVisible);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderUserPreferences.ts